import { languageObject } from "assets/data/languages";
import { SubTopicObject } from "assets/data/topics";
import { DemoUserObject } from "assets/data/usersData";
import {
    FakeNav,
    SignupForm1,
    SignupForm2,
    SignupForm3,
    SignupForm4,
    SignupForm5,
    SignupForm6,
    SignupForm7,
    SignupProgressNav,
    SignupTitle,
    TopicsModal
} from "components";
import LanguageModal from "components/files/modals/LanguageModal";
import { useState } from "react";
import { isMobilePhone } from "validator";

export type SignupStep = {
    id: string;
    title: string;
    svg: string;
    class: string;
    step: number;
};

const Signup = () => {
    const signupSteps: SignupStep[] = [
        {
            id: "step-dot-1",
            title: "Welcome, Please Enter Your Account Info.",
            svg: "user",
            class: "is-first",
            step: 0
        },
        {
            id: "step-dot-2",
            title: "Verify Your Email.",
            svg: "verify",
            class: "is-second",
            step: 16.5
        },
        {
            id: "step-dot-3",
            title: "More About You.",
            svg: "globe",
            class: "is-third",
            step: 33
        },
        {
            id: "step-dot-4",
            title: "Select Your Topics Prefrence.",
            svg: "topic",
            class: "is-fourth",
            step: 49.5
        },
        {
            id: "step-dot-5",
            title: "Follow other users.",
            svg: "follow",
            class: "is-fifth",
            step: 66
        },
        {
            id: "step-dot-6",
            title: "Secure Your Account.",
            svg: "lock",
            class: "is-sixth",
            step: 82.5
        },
        {
            id: "step-dot-7",
            title: "You're all set. Ready?",
            svg: "flag",
            class: "is-seventh",
            step: 100
        }
    ];

    const [currentStep, setCurrentStep] = useState(0);
    // ui states
    const [openLangModal, setOpenLangModal] = useState(false);
    const [openTopicModal, setOpenTopicModal] = useState(false);

    // name
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState<string | undefined>();
    const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
        // validate name here or on submit
    };
    // user name
    const [userName, setUserName] = useState("");
    const [userNameError, setUserNameError] = useState<string | undefined>();
    const handleChangeUserName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
        // validate name here or on submit
    };

    // email part
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState<string | undefined>();
    const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        // validate email here or on submit
    };

    // otp
    const [otp, setOtp] = useState("");
    const [otpValid, setOtpValid] = useState(false);

    // phone
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState<string | undefined>();
    const [validPhone, setValidPhone] = useState(false);
    const handleChangePhone = (num: string) => {
        setPhone(num);
        if (isMobilePhone(num)) {
            setValidPhone(true);
            setPhoneError(undefined);
        } else {
            setValidPhone(false);
            setPhoneError("Please Enter a Valid PHone number");
        }
    };

    // languages
    const [selectedLanguages, setSelectedLanguages] = useState<
        languageObject[]
    >([]);
    const toggleLanguage = (lang: languageObject) => {
        if (selectedLanguages.includes(lang)) {
            const newArr = selectedLanguages.filter((i) => i != lang);
            setSelectedLanguages(newArr);
        } else if (selectedLanguages.length < 4) {
            setSelectedLanguages([...selectedLanguages, lang]);
        }
    };

    // topics
    const [selectedTopics, setSelectedTopics] = useState<SubTopicObject[]>([]);
    const [topicModalTitle, setTopicModalTitle] = useState("");
    const [topicModalSubTopics, setTopicModalSubTopics] = useState<
        SubTopicObject[]
    >([]);

    const handleOpenTopicModal = (
        title: string,
        subTopics: SubTopicObject[]
    ) => {
        setTopicModalTitle(title);
        setTopicModalSubTopics(subTopics);
        setOpenTopicModal(true);
    };
    const toggleTopic = (t: SubTopicObject) => {
        if (selectedTopics.includes(t)) {
            const newArr = selectedTopics.filter((i) => i != t);
            setSelectedTopics(newArr);
        } else {
            setSelectedTopics([...selectedTopics, t]);
        }
    };

    // users
    const [followedUsers, setFollowedUsers] = useState<DemoUserObject[]>([]);

    const [pswd, setPswd] = useState("");
    const [pswdError, setPswdError] = useState<string | undefined>();
    const handleChangePswd = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPswd(e.target.value);
        // validate pswd here or on submit
    };
    // pswd part
    const [cPswd, setCPswd] = useState("");
    const [cPswdError, setCPswdError] = useState<string | undefined>();
    const handleChangeCPswd = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCPswd(e.target.value);
        e.target.value != pswd
            ? setCPswdError("Pssword must match")
            : setCPswdError(undefined);
        // validate pswd here or on submit
    };

    return (
        <>
            <div className="signup-wrapper">
                <FakeNav />

                <SignupProgressNav
                    steps={signupSteps}
                    currentStep={currentStep}
                />

                <div className="outer-panel">
                    <div className="outer-panel-inner">
                        <SignupTitle
                            steps={signupSteps}
                            currentStep={currentStep}
                        />

                        {/* panel 1 */}
                        <SignupForm1
                            step={currentStep}
                            changeStep={setCurrentStep}
                            // name
                            name={name}
                            nameError={nameError}
                            handleChangeName={handleChangeName}
                            //email
                            email={email}
                            emailError={emailError}
                            handleChangeEmail={handleChangeEmail}
                            // pswd
                            userName={userName}
                            userNameError={userNameError}
                            handleChangeUserName={handleChangeUserName}
                        />

                        {/* panel 2 */}
                        <SignupForm2
                            step={currentStep}
                            changeStep={setCurrentStep}
                            email={email}
                            otp={otp}
                            validOtp={otpValid}
                            changeOtp={setOtp}
                        />

                        {/* panel 3 */}
                        <SignupForm3
                            step={currentStep}
                            changeStep={setCurrentStep}
                            phone={phone}
                            changePhone={handleChangePhone}
                            phoneError={phoneError}
                            validePhone={validPhone}
                            openLangModal={setOpenLangModal}
                            selectedLang={selectedLanguages}
                            toggleLang={toggleLanguage}
                        />

                        {/* panel 4 */}
                        <SignupForm4
                            selectedTopics={selectedTopics}
                            toggleTopic={toggleTopic}
                            handleOpenModal={handleOpenTopicModal}
                            step={currentStep}
                            changeStep={setCurrentStep}
                        />

                        {/* panel 5 */}
                        <SignupForm5
                            step={currentStep}
                            changeStep={setCurrentStep}
                            followedUsers={followedUsers}
                            setFollowedUsers={setFollowedUsers}
                        />

                        {/* panel 6 */}
                        <SignupForm6
                            pswd={pswd}
                            changePswd={handleChangePswd}
                            pswdError={pswdError}
                            cpswd={cPswd}
                            changeCPswd={handleChangeCPswd}
                            cpswdError={cPswdError}
                            step={currentStep}
                            changeStep={setCurrentStep}
                        />

                        {/* panel 7 */}
                        <SignupForm7 step={currentStep} />
                    </div>
                </div>
            </div>
            {/* {{-- language modal --}} */}
            <LanguageModal
                opened={openLangModal}
                selectedLanguages={selectedLanguages}
                closeLangModal={setOpenLangModal}
                toggleLang={toggleLanguage}
            />
            {/* {{-- topics modals will be inserted here --}} */}
            <TopicsModal
                opened={openTopicModal}
                closeModal={setOpenTopicModal}
                selectedTopics={selectedTopics}
                toggleTopic={toggleTopic}
                title={topicModalTitle}
                subTopics={topicModalSubTopics}
            />
            {/* <div id="topics-modals"></div> */}
        </>
    );
};

export default Signup;
